<template>
  <div class="bg-white detail">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Tambah Business Merchant</p>
        <div class="mb-6 max-w-sm">
          <TextField type="text" label="ID" :disabled="true" v-model="merchantDetail.id" />
        </div>
        <div class="mb-6">
          <TextField
            type="text"
            label="Nama Perusahaan/Company Name"
            notes="Pastikan nama perusahaan belum terdaftar sebelumnya (duplikasi)."
            v-model="payloads.name"
            placeholder="Nama perusahaan"
            required
          />
        </div>
        <div class="mb-6">
          <TextField type="text" label="Nama Admin Pengirim" v-model="payloads.sender_name" placeholder="Masukan nama admin" required />
        </div>
        <div class="mb-6">
          <TextField type="number" label="No. Handphone" v-model="payloads.sender_phone" placeholder="Masukan no handphone" required />
        </div>
      </div>
      <div class="flex-1 mdmax:w-full mdmax:flex-auto">
        <div class="p-6">
          <div class="mb-6">
            <TextField type="text" label="Label Alamat (optional)" v-model="payloads.address_label" placeholder="Masukan label alamat" />
          </div>
          <div class="mb-6">
            <Textarea type="text" label="Pickup Point/Alamat Pengiriman (Sertakan Kecamatan & Kelurahan)" v-model="payloads.pickup_address" placeholder="Masukan alamat pengiriman" required />
          </div>
          <div class="mb-6">
            <TextField type="text" label="Petunjuk Pengiriman" v-model="payloads.detail_address" placeholder="Masukan petujuk sebagai patokan" />
          </div>
          <div class="mb-6 text-left relative">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block"><span class="text-system-error">*</span>Kota / Kecamatan / Kode POS Pengirim</label>
            <div class="relative">
              <TextField withIcon type="text" @input="searchCity($event)" v-model="destinationSearch" placeholder="Kota / Kecamatan / Kode POS Pengirim" />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Search />
              </div>
              <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching" />
              <transition name="fade" mode="out-in">
                <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion">
                  <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                    <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300" v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city)">
                      {{ city.village }}, {{ city.area_display }}
                    </li>
                  </ul>
                  <div class="py-4 text-center" v-else>Maaf data tidak ditemukan!</div>
                </div>
              </transition>
            </div>
          </div>
          <div class="mb-6">
            <TextField type="text" label="Koordinat Alamat (optional)" v-model="payloads.latlng" placeholder="Latitude, Longitude" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Hapus" @action="toggleConfirmModal()" :size="isMobile ? 'full' : 'regular'" type="delete" />
      <Button buttonText="Update" @action="submit()" :size="isMobile ? 'full' : 'regular'" :disabled="isDisabled" />
    </div>
    <Modal :modalVisible="visibleConfirmModal" @close="toggleConfirmModal()" width="600px" id="confirmation-modal-merchant">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700" /></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Hapus Merchant</p>
            <p class="text-sm text-neutral-500 text-left">Apakah Anda yakin untuk menghapus merchant ini?</p>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <Button buttonText="Tidak" type="secondary" @action="toggleConfirmModal()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="proceed()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { showVueToast } from '@/util'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    Button: () => import(/* webpackChunkName: "button" */ '@/components/Forms/Button'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  data() {
    return {
      payloads: {
        name: null,
        sender_name: null,
        sender_phone: null,
        pickup_address: null,
        address_label: '',
        detail_address: '',
        latlng: '',
        area_code: null
      },
      debounce: null,
      destination: '',
      destinationSearch: '',
      cityKeyword: null,
      visibleSuggestion: false,
      isSearching: false,
      visibleConfirmModal: false
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['cities']),
    ...mapGetters('merchant', ['merchantDetail']),
    merchantId() {
      return this.$route.params.id
    },
    isDisabled() {
      return !this.payloads.name || !this.payloads.sender_name || !this.payloads.sender_phone || !this.payloads.pickup_address || !this.payloads.area_code
    }
  },
  created() {
    this.getMerchanInfo()
  },
  methods: {
    ...mapActions('common', ['setToast', 'showLoading', 'hideLoading']),
    ...mapActions('master', ['getCities']),
    ...mapActions('merchant', ['getMerchantDetail', 'editMerchant', 'deleteMerchant']),
    toggleConfirmModal() {
      this.visibleConfirmModal = !this.visibleConfirmModal
    },
    proceed() {
      this.toggleConfirmModal()
      this.showLoading()
      this.deleteMerchant({
        id: this.merchantId
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 2000, primaryText: 'Berhasil menghapus merchant.', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
        })
      })
    },
    getMerchanInfo() {
      this.showLoading()
      this.getMerchantDetail({
        id: this.merchantId
      }).then((res) => {
        this.distributePayloads(res.data.data)
        this.hideLoading()
      })
    },
    distributePayloads(data) {
      console.log(data)
      this.payloads = {
        name: data.merchant,
        sender_name: data.merchant_place.sender_name,
        sender_phone: data.merchant_place.phone_number,
        pickup_address: data.merchant_place.address,
        address_label: data.merchant_place.location_label,
        detail_address: data.merchant_place.detail_address,
        latlng: data.merchant_place.location_coordinate,
        area_code: data.merchant_place.area_code
      }
      const area = {
        code: data.merchant_place.area_code,
        village: data.merchant_place.area.village,
        area_display: `${data.merchant_place.area.subdistrict}, ${data.merchant_place.area.district}`
      }
      this.selectCity(area)
    },
    searchCity(value) {
      this.cityKeyword = null
      if (value) this.isSearching = true
      this.visibleSuggestion = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.cityKeyword = value
          this.getCities({
            params: {
              page: 1,
              per_page: 1000,
              search_keyword: this.cityKeyword
            }
          }).then(() => {
            this.visibleSuggestion = true
            this.isSearching = false
          })
        }
      }, 200)
    },
    selectCity(data) {
      this.payloads.area_code = data.code
      this.destinationSearch = `${data.village}, ${data.area_display}`
      this.visibleSuggestion = false
    },
    submit() {
      this.showLoading()
      this.editMerchant({
        id: this.merchantId,
        payloads: this.payloads
      })
        .then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Perubahan Merchant Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
        .catch(() => {
          this.hideLoading()
          showVueToast('Terjadi kesalahan!', 'error', 3000)
        })
    },
    handleCallback() {
      this.$router.push('/merchant')
    }
  }
}
</script>
